<template>
    <v-container fluid :class="containerClass" class="patrol-horizontal-container">
        <v-row no-gutters class="align-center">
            <!-- Lista patroli w poziomie -->
            <v-col>
                <v-row no-gutters class="overflow-x-auto" style="flex-wrap: nowrap;">
                    <v-col v-for="patrol in displayedPatrols" :key="`patrol-${patrol.id}`" cols="auto" class="mr-2">
                        <patrol-card-vertical small :patrol="patrol" @click="showMore(patrol)" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- Dialog z detalami patrolu -->
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <material-patrol-card v-on:close="closeMore" :patrol="currentPatrol"></material-patrol-card>
        </v-dialog>
    </v-container>
</template>

<script>
// Utilities
import { get, call } from 'vuex-pathify'

export default {
    name: 'PatrolsHorizontal',

    components: {
        PatrolCardVertical: () => import('./PatrolCardVertical'),
        MaterialPatrolCard: () => import('./MaterialPatrolCard')
    },

    data: () => ({
        dialog: false,
        currentPatrol: null,
    }),

    computed: {
        patrols: get('dashboard/patrols'),
        containerClass() {
            return this.$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-2'
        },
        displayedPatrols() {
            if (!this.patrols.results) return []
            return this.patrols.results
        }
    },

    methods: {
        ...call('dashboard', [
            'fetchPatrols'
        ]),
        refreshX() {
            this.fetchPatrols()
            if (this.patrols.results) {
                this.patrols.results.forEach(patrol => {
                    if (patrol.id == this.currentPatrol?.id) {
                        this.currentPatrol = patrol
                    }
                })
            }
            if (!this.dialog) {
                clearInterval(this.timer)
            }
        },
        closeMore() {
            this.dialog = false
            clearInterval(this.timer)
        },
        showMore(patrol) {
            this.currentPatrol = patrol
            this.timer = setInterval(this.refreshX, 2500)
            this.dialog = true
        },
    },

    mounted() {
        // No longer need logic for maxVisiblePatrols
    }
}
</script>

<style scoped>
.patrol-horizontal-container {
    min-height: 130px;
    max-height: 130px;
}

.overflow-x-auto {
    overflow-x: auto;
    overflow-y: hidden;
}

.patrol-panel-top {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

@media (max-width: 600px) {
    .patrol-horizontal-container {
        min-height: 80px;
        max-height: 90px;
    }
}
</style>
